import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"
import { SpaceKey, SpaceKeySchema, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"

export const UserSpaceSettingDocumentMeta = z.object({
  user_id: UserIdSchema,
  space_key: SpaceKeySchema,
  accept_push: z.boolean(),
  accept_space_message_push: z.boolean().optional(),
})

export const UserSpaceSettingDocumentBody = z.intersection(
  UserSpaceSettingDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type UserSpaceSettingDocument = UserSpaceSettingDocumentBody & {
  id: SpaceKey,
}

export type UserSpaceSettingDocumentBody = z.infer<typeof UserSpaceSettingDocumentBody>

export class UserSpaceSettingDocuments {
  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserSpaceSettingDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: SpaceKey(doc.id),
      user_id: data["user_id"],
      space_key: data["space_key"],
      accept_push: data["accept_push"],
      accept_space_message_push: data["accept_space_message_push"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

  static toDocument(setting: UserSpaceSettingDocumentBody): object {
    const doc: Record<string, unknown> = {
      user_id: setting.user_id,
      space_key: setting.space_key,
      accept_push: setting.accept_push,
      created_at: setting.created_at,
      updated_at: setting.updated_at,
    }
    if (setting.accept_space_message_push !== undefined) {
      doc["accept_space_message_push"] = setting.accept_space_message_push
    }
    return doc
  }
}
